<template>
  <div class="static-page">
    <div class="static-page__bg"></div>

    <main class="static-page__container">
      <header class="static-page__header">
        <router-link to="/" class="back-link">← Back</router-link>
        <h1>{{ title }}</h1>
        <p v-if="subtitle" class="subtitle">{{ subtitle }}</p>
        <p v-if="lastUpdated" class="meta">Last updated: {{ lastUpdated }}</p>
      </header>

      <article class="static-page__content">
        <slot />
      </article>
    </main>
  </div>
</template>

<script>
export default {
  name: 'StaticPageLayout',
  props: {
    title: {
      type: String,
      required: true
    },
    subtitle: {
      type: String,
      default: ''
    },
    lastUpdated: {
      type: String,
      default: ''
    }
  }
};
</script>

<style scoped>
.static-page {
  min-height: 100vh;
  position: relative;
  background: #0d0d0f;
  color: #f3f4f6;
}

.static-page__bg {
  position: fixed;
  inset: 0;
  background: radial-gradient(circle at 50% -20%, #101012 0%, #000000 100%);
  pointer-events: none;
}

.static-page__container {
  position: relative;
  z-index: 1;
  max-width: 860px;
  margin: 0 auto;
  padding: 48px 20px 80px;
  box-sizing: border-box;
}

.static-page__header {
  margin-bottom: 28px;
}

.back-link {
  display: inline-block;
  margin-bottom: 18px;
  color: #00dc82;
  text-decoration: none;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.04em;
}

.back-link:hover {
  text-decoration: underline;
}

h1 {
  font-family: 'Space Grotesk', sans-serif;
  margin: 0 0 10px;
  font-size: 2.8rem;
  line-height: 1;
  font-weight: 800;
  text-transform: uppercase;
  letter-spacing: -0.5px;
  color: #00dc82;
  text-shadow: 0 0 10px rgba(0, 220, 130, 0.3);
}

.subtitle {
  margin: 0 0 10px;
  color: #a1a1aa;
  font-size: 1.05rem;
  line-height: 1.6;
}

.meta {
  margin: 0;
  color: #71717a;
  font-size: 0.88rem;
  text-transform: uppercase;
  letter-spacing: 0.08em;
}

.static-page__content {
  background: #121215;
  border: 1px solid #27272a;
  border-radius: 8px;
  padding: 28px;
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.28);
}

.static-page__content :deep(h2) {
  margin: 30px 0 12px;
  font-size: 1.25rem;
  font-weight: 800;
  color: #ffffff;
  text-transform: uppercase;
  letter-spacing: 0.04em;
}

.static-page__content :deep(h3) {
  margin: 22px 0 10px;
  font-size: 1rem;
  font-weight: 700;
  color: #e4e4e7;
}

.static-page__content :deep(p),
.static-page__content :deep(li) {
  color: #d4d4d8;
  line-height: 1.75;
  font-size: 1rem;
}

.static-page__content :deep(ul) {
  padding-left: 20px;
}

.static-page__content :deep(code) {
  background: #0a0a0c;
  border: 1px solid #27272a;
  padding: 2px 6px;
  border-radius: 4px;
  color: #f4f4f5;
}

.static-page__content :deep(a) {
  color: #00dc82;
  font-weight: 600;
}

.static-page__content :deep(a:hover) {
  color: #10b981;
}

.static-page__content :deep(.note) {
  padding: 14px 16px;
  margin: 18px 0;
  border-radius: 4px;
  border-left: 4px solid #00dc82;
  border: 1px solid rgba(0, 220, 130, 0.16);
  background: rgba(0, 220, 130, 0.08);
  color: #dcfce7;
}

.static-page__content :deep(.mini-muted) {
  color: #a1a1aa;
  font-size: 0.95rem;
}

@media (max-width: 768px) {
  .static-page__container {
    padding: 20px 16px 40px;
  }

  .static-page__content {
    padding: 20px;
  }

  h1 {
    font-size: 2.1rem;
  }
}
</style>